<template>
  <nav class="mdc-list pr-4">
    <mdc-button
      class="mdc-list-item w-full"
      ripple
      @click.native="$router.push('/email')"
    >
      <i class="material-icons mdc-list-item__graphic" aria-hidden="true"
        >keyboard_return</i
      >
      <span class="mdc-list-item__text">Back to Emails</span>
    </mdc-button>

    <hr class="mdc-list-divider" />

    <mdc-button
      v-for="option in options"
      :key="option.view"
      :class="{
        'mdc-list-item--selected':
          $store.state.logs.pagination.view === option.view,
      }"
      class="mdc-list-item w-full"
      ripple
      @click.native="setLogView(option.view)"
    >
      <i
        class="material-icons mdc-list-item__graphic"
        aria-hidden="true"
        v-text="option.icon"
      />
      <span class="mdc-list-item__text" v-text="option.label" />
      <span
        v-if="option.view === 'all'"
        class="mdc-list-item__meta"
        v-text="`(${$store.state.logs.total})`"
      />
    </mdc-button>
  </nav>
</template>

<script>
import MdcButton from '@/components/mdc/button.vue';

export default {
  components: {
    MdcButton,
  },

  data: () => ({
    options: [
      { label: 'All Logs', view: 'all', icon: 'list_alt' },
      { label: 'Error Logs', view: 'error', icon: 'error' },
      { label: 'Warning Logs', view: 'warning', icon: 'warning' },
      { label: 'Success Logs', view: 'success', icon: 'check_circle' },
    ],
  }),

  mounted() {},

  methods: {
    setLogView(view) {
      this.$store.commit('logs/setView', view);
    },
  },
};
</script>
